
export const generateMasterCategoryUrl = (catName, catId) => {
    let catObjUrl = `category/${catName
        .toLowerCase()
        .trim()
        .replace(/ /g, "-")}-mc-${catId}`;
    return catObjUrl;
}